import CollectionAdmin from "./CollectionAdmin";

export default function HearingAidSuppliersAdmin() {
  return (
    <CollectionAdmin
      title="Høreapparat-leverandører"
      basePath="/api/admin/hearing-aid-suppliers"
      fields={[
        { key: "name", label: "Navn", required: true },
        { key: "phone", label: "Telefon", required: true },
      ]}
    />
  );
}
